<template>
  <div class="spinner-container">
    <div class="spinner">
      <div v-for="n in count" class="line" :class="`line-${n}`" :key="n"></div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      fixed: {
        type: Boolean,
        default: false,
        required: false,
      },
      count: {
        type: Number,
        default: 5,
        required: false,
      },
    },
    data() {
      return {};
    },
    computed: {
      classObject() {
        return {
          fixed: this.fixed,
        };
      },
    },
  };
</script>
